import axios from 'axios';
import { getBaseUrlAnalista, getBaseUrlSolicitante, ensureProtocol } from '../config/backend';

export function getTiposChamadoConfig(isSolicitante) {
  if (isSolicitante) {
    const base = getBaseUrlSolicitante() || ensureProtocol(localStorage.getItem('ipBackend') || '');
    return base ? { baseUrl: base, path: '/api/tiposChamado' } : { baseUrl: '', path: '' };
  }
  const base = getBaseUrlAnalista() || ensureProtocol(localStorage.getItem('ipBackend2') || '');
  return base ? { baseUrl: base, path: '/tipos-chamado/ativos' } : { baseUrl: '', path: '' };
}

export async function fetchTiposChamado(isSolicitante = false) {
  const { baseUrl, path } = getTiposChamadoConfig(isSolicitante);
  if (!baseUrl || !path) return [];
  const token = localStorage.getItem('token');
  try {
    const res = await axios.get(baseUrl + path, {
      headers: token ? { Authorization: token } : {},
      timeout: 10000
    });
    const raw = res?.data;
    return Array.isArray(raw) ? raw : [];
  } catch (err) {
    console.error('Erro ao carregar tipos de chamado:', err);
    return [];
  }
}

export function getNomeTipo(tipos, tipoVal) {
  if (!Array.isArray(tipos) || tipos.length === 0) return 'Sem tipo';
  const n = tipoVal != null && tipoVal !== '' ? Number(tipoVal) : NaN;
  if (Number.isNaN(n)) return 'Sem tipo';
  const t = tipos.find((x) => x.id === n || x.codigo_legado === n);
  return t?.nome ?? 'Sem tipo';
}
